import React from 'react';
import Link from 'gatsby-link';

const Header = () => (
  <div
    style={{
      // background: 'gray',
      marginBottom: '1.45rem',
    }}
  >
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '1.45rem 1.0875rem',
      }}
    >
      <h1 style={{ margin: 0, fontSize: 40 }}>
        <Link
          to="/"
          style={{
            color: 'black',
            fontFamily: 'Prociono',
            textDecoration: 'none',
          }}
        >
          Terminus
        </Link>
      </h1>
    </div>
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js